import { Box } from '@mui/material';
import { useFormikContext } from 'formik';
import { ContentCard } from 'components/Card';
import { getTrans } from 'modules/i18n';
import { CVBuilderFormValues, HardSkillEntry } from 'utils/cv-form-db';
import { StepProgressIndicator } from '../../components/StepProgressIndicator';
import { HardSkillDetailsList } from './HardSkillDetailsList';
import { HardSkillsForm } from './HardSkillsForm';

interface HardSkillsContentProps {
  isFormOpen: boolean;
  isEditing: boolean;
  editingItem: HardSkillEntry | null;
  onAdd: (item: HardSkillEntry) => void;
  onEdit: (item: HardSkillEntry) => void;
  onCancel: () => void;
  onAddClick: () => void;
  onEditClick: (index: number) => void;
  onDeleteClick: (index: number) => void;
}

export const HardSkillsContent = ({
  isFormOpen,
  isEditing,
  editingItem,
  onAdd,
  onEdit,
  onCancel,
  onAddClick,
  onEditClick,
  onDeleteClick
}: HardSkillsContentProps) => {
  const { values } = useFormikContext<CVBuilderFormValues>();

  return (
    <>
      <ContentCard
        title={getTrans('cvBuilderPage.hardSkills.title')}
        titleVariant="h4"
      >
        <Box sx={{ mb: 2 }}>
          <StepProgressIndicator
            showPercentage={true}
            size="medium"
            variant="compact"
          />
        </Box>
      </ContentCard>
      {isFormOpen ? (
        <HardSkillsForm
          mode={isEditing ? 'edit' : 'add'}
          initialValues={editingItem || undefined}
          onSubmit={isEditing ? onEdit : onAdd}
          onCancel={onCancel}
        />
      ) : (
        <HardSkillDetailsList
          values={values}
          onAddClick={onAddClick}
          onEditHardSkill={onEditClick}
          onDeleteHardSkill={onDeleteClick}
        />
      )}
    </>
  );
};
